import { Box, Grid, TableCell, TableRow } from "@mui/material";
import React, { useEffect, useState } from "react";
import TableDesign, {
  TableHeading,
} from "../../../components/common/table/TableDesign";
import ManageTenant from "./manageClient/ManageTenant";
import PageTitle from "../../../components/pageTitle/PageTitle";
import trunkLogo from "../../../assets/images/trunk.png";
import { useSelector } from "react-redux";
import { getAllTelnetAction } from "../../../store/reducers/adminClientsSlice";
import { useDispatch } from "react-redux";
import StatusBadge from "../../../components/common/StatusBadge";

interface Client {
  client_id: string;
  logo?: string;
  company: string;
  email: string;
  status: string;
  setTenantId: any;
  tenantId?: any;
}

interface FilterOption {
  page: number;
  limit: number;
  orderBy: string;
  orderIn: string;
}

interface ClientListProps {
  setTenantId: any;
  tenantId?: any;
}

const ClientList: React.FC<ClientListProps> = ({ setTenantId, tenantId }) => {
  const dispatch = useDispatch();
  const { clients, clientPagination } = useSelector(
    (state: any) => state.adminClients
  );
  const [filterOption, setFilterOption] = useState<FilterOption>({
    page: 1,
    limit: 10,
    orderBy: "created_at",
    orderIn: "DESC",
  });

  const [isLoader] = useState(false);

  const tableHeadings: TableHeading[] = [
    { label: "#" },
    { label: "Logo", align: "left" },
    { label: "Company", align: "left" },
    { label: "Email", align: "left" },
    { label: "Status", align: "center" },
  ];

  const [open, setOpen] = useState(false); // State variable to manage dialog open/close
  const { isClientDeleteSuccess, isClientToggleResponse,isClientSuspensionResponse } = useSelector(
    (state: any) => state?.adminClients);

  // Function to toggle the open/close status of the dialog
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };
  useEffect(() => {
    dispatch(getAllTelnetAction(filterOption));
  }, [dispatch, filterOption]);

  useEffect(() => {
    if(isClientDeleteSuccess || isClientToggleResponse || isClientSuspensionResponse){
      dispatch(getAllTelnetAction(filterOption));
    }
  }, [isClientDeleteSuccess,isClientToggleResponse,isClientSuspensionResponse]);

  useEffect(() => {
    console.log("State:", { clients, clientPagination });
    console.log("clients", clients);
    console.log("clientPagination", clientPagination);
  }, [clients, clientPagination]);

  return (
    <>
      {open && (
        <ManageTenant
          selectClient={""}
          open={open}
          onHide={handleClose}
          title="Add Client Details"
        />
      )}
      <Grid container>
        <Grid item md={12} xs={12}>
          <PageTitle title="Clients" button="Add" onClick={handleOpen} />
          <TableDesign
            tableHeadings={tableHeadings}
            pagination={clientPagination}
            isLoader={isLoader}
            stickyHeader={true}
            filterOption={filterOption}
            setFilterOption={setFilterOption}
          >
            {clients.length > 0 ? (
              clients?.map((val: Client, idx: number) => (
                <TableRow 
                  key={val?.client_id}
                  onClick={() => setTenantId(val?.client_id)}
                  sx={{
                    cursor: "pointer",
                    backgroundColor:
                      tenantId === val.client_id ? "#f0f0f0" : "none",
                  }}
                >
                  <TableCell>{clientPagination?.currentPage > 1 ? ((clientPagination?.currentPage-1)*10)+(idx + 1) : idx + 1}</TableCell>
                  <TableCell align="center" style={{ padding: "0px",cursor:'pointer' }}>
                    {val?.logo === null || val?.logo === "" ? (
                      <img
                        src={trunkLogo}
                        alt="logo"
                        style={{ width: "36px" }}
                      />
                    ) : (
                      <img
                        src={val?.logo}
                        alt="logo"
                        style={{ width: "36px" }}
                      />
                    )}
                  </TableCell>
                  <TableCell>{val?.company}</TableCell>
                  <TableCell>{val.email}</TableCell>
                  <TableCell align="center">
                    <StatusBadge status={val.status} />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5}>
                  <Box
                    sx={{
                      height: "60vh",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      position: "relative",
                    }}
                  >
                    <span style={{ position: "absolute" }}>
                      Add a New Client!
                    </span>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableDesign>
        </Grid>
      </Grid>
    </>
  );
};

export default ClientList;
